var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgAquamarine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0092 20.4013L38.1516 1.18191C36.2022 -0.390715 33.4193 -0.390715 31.4698 1.18191L7.6195 20.4013C5.92367 21.771 5.50334 24.177 6.62664 26.0396L32.4192 68.6527C33.5062 70.4572 36.1225 70.4572 37.2095 68.6527L63.0021 26.0396C64.1254 24.177 63.705 21.7638 62.0092 20.4013Z",
    fill: "#029CD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8034 70C34.8106 70 34.8179 70 34.8251 70C35.3469 70 35.818 69.6594 35.9847 69.1593L49.6963 28.6769H19.925L33.6439 69.1593C33.8105 69.6594 34.2744 69.9928 34.8034 70Z",
    fill: "#23DEE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3497 24.1837C62.9079 23.5822 63.3354 21.4877 62.0382 20.4224C62.031 20.4152 62.0165 20.4079 62.0092 20.4007L58.777 17.7989L38.1517 1.18128C37.1806 0.398592 36.0065 0 34.8252 0C34.8252 0 34.8252 0.00724713 34.818 0.00724713L49.6963 28.6769L61.3497 24.1837Z",
    fill: "#13BDDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27897 24.1837C6.72084 23.5822 6.29326 21.4877 7.59049 20.4224C7.59774 20.4152 7.61223 20.4079 7.61948 20.4007L10.8517 17.7989L31.4698 1.18128C32.4409 0.398592 33.6222 0 34.8035 0C34.8035 0 34.8035 0.00724713 34.8107 0.00724713L19.9251 28.6769L8.27897 24.1837Z",
    fill: "#23DEE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6963 28.6769L53.2401 27.3072L55.0954 26.5897C56.1825 26.1694 56.4071 24.7272 55.5012 23.9952L53.6097 22.4661L45.3915 15.8422C44.6016 15.2045 43.4928 16.0886 43.9421 17.0018L49.6963 28.6769Z",
    fill: "#0081BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6963 28.6768L35.8977 0.681185C35.6948 0.268099 35.2817 0.00720215 34.8251 0.00720215C34.8179 0.00720215 34.8179 0.00720215 34.8106 0.00720215C34.3541 0.00720215 33.9337 0.275346 33.7381 0.681185L19.925 28.6768H49.6963Z",
    fill: "#C7FFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8167 36.8371L20.0193 28.5827L18.9177 28.1623L14.0404 26.2781C13.3737 26.0172 12.7939 26.8216 13.2505 27.3724L21.6209 37.5111C22.1065 38.1054 23.0631 37.5691 22.8167 36.8371Z",
    fill: "#97F4F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquamarine);
export default __webpack_public_path__ + "static/media/aquamarine.4a38a796.svg";
export { ForwardRef as ReactComponent };